import { jsPDF } from "jspdf";

function safeFilename(value) {
  return String(value || "dummy-actionstep-document.pdf")
    .replace(/[^a-zA-Z0-9._ -]/g, "")
    .replace(/\s+/g, " ")
    .trim() || "dummy-actionstep-document.pdf";
}

function documentSummary(document) {
  const name = document.name.toLowerCase();
  if (name.includes("client details")) return ["Sample client details", "Identity and contact information verified for demonstration purposes.", "No real personal information is contained in this document."];
  if (name.includes("email to client")) return ["Sample correspondence", "The fictional client was reminded of the upcoming court date and arrival time.", "Instructions and attendance arrangements were confirmed."];
  if (name.includes("bail application")) return ["Sample bail application", "Draft grounds and fictional supporting circumstances for simulator testing.", "This is not a court-ready document and has no legal effect."];
  if (name.includes("court attendance")) return ["Sample court document", "Notice of the fictional matter's next listed appearance.", "Prepared solely to test document storage and download behaviour."];
  if (name.includes("grant of aid")) return ["Sample legal aid grant", "Fictional funding approval and grant reference for workflow testing.", "This is not an approval issued by Victoria Legal Aid."];
  if (name.includes("funding position")) return ["Sample funding note", "The fictional matter's funding position is recorded for demonstration.", "No payment or funding entitlement is created by this document."];
  if (name.includes("police brief")) return ["Sample evidence index", "Fictional index of brief materials, statements and exhibits.", "No police or evidentiary material is included."];
  if (name.includes("brief to counsel")) return ["Sample counsel brief", "Fictional instructions, issues and upcoming appearance information.", "Prepared only to demonstrate an Actionstep folder workflow."];
  return ["Sample accounts document", "Fictional professional fees summary for portal and billing workflow testing.", "No amount is payable and this is not a tax invoice."];
}

export function downloadActionstepSimulatorPdf({ document, matter }) {
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const [heading, paragraphOne, paragraphTwo] = documentSummary(document);
  const fileName = safeFilename(document.name.endsWith(".pdf") ? document.name : `${document.name}.pdf`);

  pdf.setFillColor(88, 28, 135);
  pdf.rect(0, 0, 210, 30, "F");
  pdf.setTextColor(255, 255, 255);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text("ACTIONSTEP SIMULATOR", 18, 18);

  pdf.setTextColor(30, 41, 59);
  pdf.setFontSize(16);
  pdf.text(heading, 18, 47);
  pdf.setDrawColor(203, 213, 225);
  pdf.line(18, 53, 192, 53);

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);
  const details = [
    ["Fictional client", matter.client.fullName],
    ["Matter reference", matter.client.fileNumber],
    ["Action ID", matter.externalId],
    ["Folder", document.folderName || "Unfiled"],
    ["Court", matter.matter.court],
    ["Next appearance", matter.matter.nextAppearanceDate],
  ];
  let y = 66;
  details.forEach(([label, value]) => {
    pdf.setFont("helvetica", "bold");
    pdf.text(`${label}:`, 18, y);
    pdf.setFont("helvetica", "normal");
    pdf.text(String(value || "Not recorded"), 56, y);
    y += 8;
  });

  y += 6;
  pdf.setFontSize(11);
  pdf.text(pdf.splitTextToSize(paragraphOne, 174), 18, y);
  y += 18;
  pdf.text(pdf.splitTextToSize(paragraphTwo, 174), 18, y);

  pdf.setFillColor(254, 242, 242);
  pdf.setDrawColor(248, 113, 113);
  pdf.roundedRect(18, 145, 174, 32, 2, 2, "FD");
  pdf.setTextColor(153, 27, 27);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(11);
  pdf.text("DUMMY DOCUMENT - NOT A REAL CLIENT FILE", 26, 158);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9);
  pdf.text("Generated locally by the LACW Actionstep Simulator for testing only.", 26, 168);

  pdf.setTextColor(100, 116, 139);
  pdf.setFontSize(8);
  pdf.text(`Simulator record ${document.id}`, 18, 285);
  pdf.text("Page 1 of 1", 175, 285);
  pdf.save(fileName);
}
